import {useGetFriendlyUrl} from "utils/hooks/useGetFriendlyUrl";

import {useGetQueue} from "modules/queues/infrastructure/useGetQueue";

import { ChakraText } from "components/ChakraText";

interface IProps {
  queueId: string;
}

const QueueName = ({ queueId }: IProps) => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const { data: queue } = useGetQueue(queueId, friendlyUrl);

  return <ChakraText>{queue?.name}</ChakraText>;
};

export { QueueName };
